module.exports = function(service) {
	'use strict'
	service.factory('getMicrositesBaseOnUrl', getMicrositesBaseOnUrl);
	getMicrositesBaseOnUrl.$inject = ['config'];
	function getMicrositesBaseOnUrl(config) {
	    return function(url) {
            if(!config.microsites || config.microsites.length==0) return 'telegraf'
            for(var i = 0; i<config.microsites.length;i++) {
                if(url.includes(config.microsites[i].baseurl)) {
                    return config.microsites[i]._id 
                }
            }
            return 'telegraf'
	    }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/getMicrositesBaseOnUrlService.js
// module id = 607
// module chunks = 0